import { Authenticated as RefineAuthenticated } from '@refinedev/core';
import { Spin } from 'antd';
import { Navigate } from 'react-router';

import type { ReactNode } from 'react';

type AuthenticatedProps = {
  children: ReactNode;
};

/**
 * Гард для приватных роутов.
 *
 * Использует Refine `<Authenticated>` поверх `authProvider.check`.
 * Пока идёт проверка — спиннер. Если не аутентифицирован — редирект на `/login`.
 */
export function Authenticated({ children }: AuthenticatedProps) {
  return (
    <RefineAuthenticated
      key="authenticated"
      fallback={<Navigate to="/login" replace />}
      loading={
        <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
          <Spin size="large" />
        </div>
      }
    >
      {children}
    </RefineAuthenticated>
  );
}
